<template>
  <div class="p-4 overflow-y-auto h-full pb-32">
    <div class="mobile-status-padding"></div>
    <!-- <div
      class="absolute w-full h-screen top-0 left-0 opacity-60"
      style="
        background: radial-gradient(
          circle at 5rem 5rem,
          #ffd2ab,
          transparent 30%
        );
      "
    ></div> -->
    <div class="p-6 rounded-[2rem] bg-black relative">
      <div class="text-white text-3xl font">Trackez vos colis</div>
      <div class="pt-2 text-lg w-full text-slate-200">
        Entrez le numéro de tracking dans le champ ci dessous pour continuer
      </div>
      <div class="py-3"></div>
      <div class="rounded-full bg-white relative">
        <input
          v-model="searchValue"
          type="search"
          placeHolder="Traquez un colis"
          class="bg-white w-full pr-36 pl-6 h-[4rem] rounded-full hover:outline-none focus:outline-none focus:ring-2 focus:ring-black/10"
          @keydown.enter="handleSearch"
        />
        <button
          @click="handleSearch"
          :disabled="isSearching || !searchValue?.trim()"
          class="absolute right-1 top-1 h-[3.5rem] px-8 rounded-full bg-black text-white font-semibold flex items-center justify-center gap-2 hover:bg-black/90 active:scale-95 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100 min-w-[120px]"
        >
          <svg v-if="!isSearching" class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <span v-if="!isSearching" class="hidden sm:inline">Rechercher</span>
          <svg v-else class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </button>
      </div>
    </div>

    <div class="py-4"></div>

    <div class="relative">
      <button
        class="buttonComponent w-full"
        @click="openWizard"
      >
        Envoyer un colis
      </button>
    </div>

    <div class="relative">
      <div class="text-xl font-bold title-color px-6 mt-8">
        Livraisons récentes
      </div>
      <PackagesList
        @itemClick="
          el => {
            $refs.PackageDetails.showDetails(el)
          }
        "
        @startNewDeliveryRequest="
          openWizard
        "
      />
    </div>
    <PackageDetailsDialog ref="PackageDetails" />
    <TrackingSearchResultDialog 
      ref="TrackingSearchResult" 
      @openDetails="pkg => { $refs.PackageDetails.showDetails(pkg) }"
    />
    <div class="py-8"></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';
import PackagesList from '../components/PackagesList.vue';
import PackageDetailsDialog from '../components/PackageDetailsDialog.vue';
import TrackingSearchResultDialog from '../components/TrackingSearchResultDialog.vue';

const searchValue = ref('');
const isSearching = ref(false);
const TrackingSearchResult = ref(null);

const openWizard = () => {
  bus.emit(constants.EVENTS.PACKAGES.WIZARD_OPEN);
};

const handleSearch = () => {
  const code = searchValue.value?.trim();
  if (!code) {
    bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
      type: 'error',
      title: 'Champ vide',
      body: 'Veuillez entrer un numéro de tracking'
    });
    return;
  }

  isSearching.value = true;
  bus.emit(constants.EVENTS.PACKAGES.TRACKING_SEARCH, code);
};

// Listen for search results
bus.on(constants.EVENTS.PACKAGES.TRACKING_FOUND, (packageData) => {
  isSearching.value = false;
  if (packageData && TrackingSearchResult.value) {
    TrackingSearchResult.value.showResult(packageData);
  }
});

bus.on(constants.EVENTS.PACKAGES.TRACKING_NOT_FOUND, () => {
  isSearching.value = false;
});

bus.on(constants.EVENTS.PACKAGES.TRACKING_SEARCH_ERROR, () => {
  isSearching.value = false;
});

onMounted(() => {
  bus.emit(constants.EVENTS.PACKAGES.LOAD);
});
</script>
